import React from "react";
import profile from "../../images/profile/Untitled-6.jpg";
import file from "../../images/Resume/Mern_Stack_Resume_Of_KUTUB UDDIN.pdf";

const About = () => {
  return (
    <div id="about" className="bg-gray-800 py-10">
      <div className="container mx-auto px-4 lg:grid lg:grid-cols-12 gap-6 items-center">
        {/* Image Section */}
        <div className="lg:col-span-5 flex justify-center">
          <img src={profile} alt="Kutub Uddin" className="w-full max-w-sm rounded-lg shadow-lg" />
        </div>

        {/* Content Section */}
        <div className="lg:col-span-7 text-left mt-8 lg:mt-0">
          <h1 className="text-white text-2xl font-semibold">About Me</h1>
          <h2 className="text-4xl font-extrabold text-[#00A9FF] mb-4">I'm Kutub Uddin</h2>
          <p className="text-white text-justify">
            Outside of just being pretty awesome, I am currently pursuing a 
            Bachelor's in Business Administration at Premier University, Chittagong, Bangladesh. 
            Programming is my passion, and my dream is to become a Senior Developer in Bangladesh. 
            Over the past 1.5 years, I have dedicated myself to learning various technologies 
            with full attention and commitment. I have successfully completed a Web Development Course.
          </p>

          {/* Resume Download Button */}
          <a href={file} download className="inline-block text-[#00A9FF] border font-bold border-[#00A9FF] px-6 py-3 mt-6 rounded-lg shadow-md hover:bg-[#ffffff] transition">
            Download Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
